export enum CookieKeys {
  GCLID = 'gclid',
  SUBSCRIBED = 'subscribed',
  UNLOCK = 'unlock'
}
